export default "__VITE_ASSET__DB$kW0fB__"